module.exports = __webpack_public_path__ + "img/find-jobs-bg.c3e5ae16.png";